import React, { useContext, useEffect, useState } from "react";
import classes from "./PRTab.module.css";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import {
  Autocomplete,
  Box,
  Fade,
  Modal,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import { MoreHoriz } from "@mui/icons-material";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import { emptyCheck } from "../../../utils/validations";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import { useSelector } from "react-redux";

import { CurrencyContext } from "../../../context/CurrencyContext";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import DataTable from "../../../components/common/DataTable/DataTable";
import { getUniqueData } from "../../../utils/getUniqueData";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import { formatInrAmount } from "../../../utils/currencyFormat";

const PRApproverSlab = () => {
  const loginData = useSelector((state) => state.loginData.value);
  const [auth_token] = useState(loginData?.auth_token);
  const [user_token] = useState(loginData?.user?.token);

  const [openapprovalmodal, setOpenApprovalModal] = useState(false);
  const [successpopup, setSuccessPopUp] = useState(false);
  const [openViewItemPopup, setOpenViewItemPopup] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);

  const [getuserlist, setUserList] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [configUsers, setConfigUsers] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(1);

  const [uniqueData, setUniqueData] = useState();
  const { fromCurrency, setFromCurrency } = useContext(CurrencyContext);

  const [startPrice, setStartPrice] = useState({
    value: "",
    isValid: true,
  });
  const [endPrice, SetEndPrice] = useState({
    value: "",
    isValid: true,
  });
  const [stageName, setStageName] = useState({
    value: "",
    isValid: true,
  });

  const [getsavedposlab, setSavedPOSlab] = useState([]);

  const [editSlabId, setEditSlabId] = useState(null);

  // useEffect

  const handleGetPOslab = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_all_po_slab}`,
        { admin_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      setConfigUsers(response.data.response);
    } catch (error) {
      console.log("error");
    }
  };

  const getAllUserList = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.all_user_list}`,
        { buyer_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      const filteredUsers = response?.data.filter(
        (user) => user.token !== user_token
      );

      setUserList(filteredUsers);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_Department}`,
        { user_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      console.log(response);
      setDepartmentList(response.data?.data || []);
      // const filteredUsers = response?.data.filter(
      //     (user) => user.token !== user_token
      // );

      // setUserList(filteredUsers)
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  useEffect(() => {
    getAllUserList();
    handleGetPOslab();
    getAllDepartment();
  }, []);

  const handleOpenAddItem = () => {
    setOpenApprovalModal(true);
  };

  const handleEditAddItem = (editData = null) => {
    // console.log("getuserlist", getuserlist);
    // console.log({ editData })
    // resetFormFields();
    // if (editData) {
    //     setIsEditMode(true);
    //     setEditSlabId(editData.id);
    //     setStageName({ value: editData.slab_name || "", isValid: true });
    //     setStartPrice({ value: editData.price_start || "", isValid: true });
    //     SetEndPrice({ value: editData.price_end || "", isValid: true });
    //     setFromCurrency({
    //         currency: editData.currency_type || "",
    //         countryName: editData.country_name || "",
    //     });
    //     const matchedLevel1 = editData.usersList?.slice(0, 1).map(user => {
    //         const match = getuserlist.find(
    //             (u) =>
    //                 `${u.first_name || ''} - ${u.designation || ''}`.trim() ===
    //                 user.approver_name.trim()
    //         );
    //         return match || null;
    //     }).filter(Boolean) || [];

    //     setSelectedApprovers(matchedLevel1);

    //     const moreApprovers = editData.usersList?.slice(1).map((user, index, arr) => {
    //         const match = getuserlist.find(
    //             (u) =>
    //                 `${u.first_name || ''} - ${u.designation || ''}`.trim() ===
    //                 user.approver_name.trim()
    //         );
    //         return {
    //             id: index + 1,
    //             value: match?.token || '',
    //             showAdd: index === arr.length - 1,
    //         };
    //     }) || [];

    //     setApprovers(moreApprovers);
    // } else {
    //     setIsEditMode(false);
    //     setEditSlabId(null);
    // }
    // setOpenApprovalModal(true);

    resetFormFields();

    if (editData) {
      setIsEditMode(true);
      setEditSlabId(editData.id);

      setStageName({ value: editData.slab_name || "", isValid: true });
      setStartPrice({ value: editData.price_start || "", isValid: true });
      SetEndPrice({ value: editData.price_end || "", isValid: true });
      setFromCurrency({
        currency: editData.currency_type || "",
        countryName: editData.country_name || "",
      });

      // 👉 Map ALL users to selectedApprovers (no level splitting)
      const matchedApprovers = editData.usersList
        .map((user) => {
          const match = getuserlist.find(
            (u) =>
              `${u.first_name || ""} - ${u.designation || ""}`.trim() ===
              user.approver_name.trim()
          );
          return match || null;
        })
        .filter(Boolean);

      setSelectedApprovers(matchedApprovers);
      setApprovers([]); // clear dynamic list if not using it
    } else {
      setIsEditMode(false);
      setEditSlabId(null);
    }

    setOpenApprovalModal(true);
  };

  const resetFormFields = () => {
    setStageName({ value: "", isValid: true });
    setStartPrice({ value: "", isValid: true });
    SetEndPrice({ value: "", isValid: true });
    // setFromCurrency({
    //     currency: "",
    //     countryName: ""
    // });
    setSelectedApprovers([]);
    setApprovers([]);
  };

  const handleCloseAddItem = () => {
    resetFormFields();
    setOpenApprovalModal(false);
    setIsEditMode(false);
  };

  const handleAddApprover = () => {
    const updated = [...approvers];
    if (updated.length > 0) {
      updated[updated.length - 1].showAdd = false;
    }
    updated.push({ id: approvers.length + 1, value: "", showAdd: true });
    setApprovers(updated);
  };

  const handleRemoveApprover = (id) => {
    const updated = approvers.filter((item) => item.id !== id);
    if (updated.length > 0) {
      updated[updated.length - 1].showAdd = true;
    }
    setApprovers(updated);
  };

  const renderApproverInputs = () => {
    approvers.map((approver, index) => (
      <div
        key={approver.id}
        style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}
      >
        <Autocomplete
          disablePortal
          options={getuserlist}
          sx={{ width: 300 }}
          getOptionLabel={(option) =>
            `${option.first_name}-${option.designation || ""}`
          }
          value={getuserlist.find((u) => u.token === approver.value) || null}
          onChange={(event, newValue) => {
            const updated = [...approvers];
            updated[index].value = newValue?.token || "";
            setApprovers(updated);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={`Approver ${index + 2}`}
              placeholder="Choose user"
            />
          )}
        />
        {approver.showAdd ? (
          <Dbutton label="Add" onClick={handleAddApprover} btnHeight="3.5rem" />
        ) : (
          <DButtonOutlined
            label="Remove"
            onClick={() => handleRemoveApprover(approver.id)}
            btnHeight="3.5rem"
          />
        )}
      </div>
    ));
  };

  const handleSavePOslab = async () => {
    let isValid = true;

    if (!stageName.value.trim()) {
      setStageName((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      setStageName((prev) => ({ ...prev, isValid: true }));
    }

    if (!startPrice.value) {
      setStartPrice((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      setStartPrice((prev) => ({ ...prev, isValid: true }));
    }

    if (
      !endPrice.value ||
      parseFloat(endPrice.value) < parseFloat(startPrice.value)
    ) {
      SetEndPrice((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      SetEndPrice((prev) => ({ ...prev, isValid: true }));
    }

    // if (selectedApprovers.length === 0) {
    //     setSelectedApproversError(true);
    //     isValid = false;
    // } else {
    //     setSelectedApproversError(false);
    // }

    if (!isValid) return;

    try {
      const level1UserTokens = selectedApprovers.map((user) => user.token);
      const levelNUserTokens = approvers
        .map((approver) => approver.value)
        .filter(Boolean);
      const allUserTokens = [...level1UserTokens, ...levelNUserTokens];

      const formData = new FormData();
      formData.append("stage_name", stageName.value);
      formData.append("price_start", startPrice.value);
      formData.append("price_end", endPrice.value);
      formData.append("currency", fromCurrency.currency || "");
      formData.append("country_name", fromCurrency.countryName || "");
      formData.append("users", JSON.stringify(allUserTokens)); // stringify list
      formData.append("admin_token", user_token);
      formData.append("dept_name", selectedDepartment?.name || "");

      if (isEditMode && editSlabId) {
        formData.append("id", editSlabId);
      }

      const response = await axios.post(
        API_ENDPOINT.ins_pr_slab_config,
        formData,
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSuccessPopUp(true);
        // getsavedposlab()
        // setOpenApprovalModal(false);
      }
    } catch (error) {
      console.error(
        "Error saving PR slab:",
        error.response?.data || error.message
      );
      alert("Something went wrong while saving the slab.");
    }
  };

  const PoslabItemInputs = [
    <DTextInput
      label="Stage Name"
      type="text"
      maxLength={250}
      value={stageName.value}
      onChange={(e) => {
        let val = e.target.value;
        setStageName({
          value: val,
          isValid: emptyCheck(e.target.value),
        });
      }}
      error={!stageName.isValid}
      customClassName={classes.popupFields}
      errorMsg={"Stage Name is required"}
      size={"45%"}
    />,
    <SelectCountry
      customClass={classes.approvercountry}
      value={fromCurrency}
      setValue={setFromCurrency}
      label="Currency"
      width={true}
      onChange={(newCurrency) => {
        setFromCurrency({
          ...newCurrency,
        });
      }}
    />,
    <DTextInput
      label="Start Price "
      type="number"
      maxLength={250}
      value={startPrice.value}
      onChange={(e) => {
        let val = e.target.value;
        setStartPrice({
          value: val,
          isValid: emptyCheck(e.target.value),
        });
      }}
      error={!startPrice.isValid}
      customClassName={classes.popupFields}
      errorMsg={"Start Price required"}
      size={"45%"}
    />,
    <DTextInput
      label="End Price"
      type="number"
      // maxLength={250}
      value={endPrice.value}
      onChange={(e) => {
        let val = e.target.value;
        SetEndPrice({
          value: val,
          isValid: emptyCheck(e.target.value),
        });
      }}
      error={!endPrice.isValid}
      customClassName={classes.popupFields}
      errorMsg={
        endPrice.value != "" && endPrice.value <= startPrice.value
          ? "End Price should not be lesser than Start Price"
          : "End Price required"
      }
      size={"45%"}
    />,

    <Autocomplete
      disablePortal
      options={departmentList}
      getOptionLabel={(option) => option.name || ""}
      value={selectedDepartment}
      onChange={(e, newVal) => setSelectedDepartment(newVal)}
      sx={{ width: 230, m: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Department"
          placeholder="Select department"
          sx={{
            "& .MuiInputBase-root": { fontSize: "14px" },
            "& .MuiInputLabel-root": { fontSize: "14px" },
            "& .MuiAutocomplete-tag": { fontSize: "12px" },
          }}
        />
      )}
    />,

    <Autocomplete
      multiple
      disablePortal
      options={getuserlist}
      sx={{ width: 230, m: 1 }}
      getOptionLabel={(option) => {
        if (!option || typeof option !== "object") return "";
        return `${option.first_name || "N/A"} - ${option.designation || ""}`;
      }}
      value={selectedApprovers}
      onChange={(event, newValue) => setSelectedApprovers(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Approvers"
          placeholder="Choose user(s) to approve"
          sx={{
            "& .MuiInputBase-root": { fontSize: "14px" },
            "& .MuiInputLabel-root": { fontSize: "14px" },
            "& .MuiAutocomplete-tag": { fontSize: "12px" },
          }}
        />
      )}
    />,

    // Dynamic approver fields
    <div>{renderApproverInputs()}</div>,
  ];

  const Tableheadings = [
    { label: "Name", field: "slab_name", col_width: "220px", noWrap: true },
    { label: "Users", field: "users" },
    { label: "Department", field: "department" },
    { label: "Currency", field: "currency_type" },
    { label: "Start Price", field: "price_start", additional_data: "currency" },
    { label: "End Price", field: "price_end", additional_data: "currency" },
  ];

  const handleBack = () => {
    resetFormFields();
    handleGetPOslab();
    setSuccessPopUp(false);
    setOpenApprovalModal(false);
    setIsEditMode(false);
  };

  const viewUserHeading = (
    <HeaderTitle
      titleText={"Add Slab Range" || <MoreHoriz sx={{ fontSize: "30px" }} />}
      customclass={classes.heading_pop_pup}
    />
  );

  const viewTextActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseAddItem}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <Dbutton
      label={`${isEditMode ? "Update" : "Submit"}`}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleSavePOslab}
      // disabled={sendmsg && !errorMessages}
    />,
  ];

  const itemsData = configUsers;
  const processedItemsData = itemsData.map((item) => ({
    ...item,
    usersList: item.users, // keep original object array for modal
    users: item.users.map((user) => user.approver_name).join(", "), // string for table
  }));

  const handleOpenViewItemPopup = (unique_id) => {
    let rowData = getUniqueData(processedItemsData, "id", unique_id.id);

    setUniqueData(rowData);
    setOpenViewItemPopup(true);
  };

  const handleCloseViewItemPopup = () => {
    setOpenViewItemPopup(false);
  };

  const filteredData = processedItemsData.filter((item) => {
    if (!searchQuery) return true;

    const query = searchQuery.toLowerCase();
    return (
      (item.slab_name && item.slab_name.toLowerCase().includes(query)) ||
      (item.users && item.users.toLowerCase().includes(query)) ||
      (item.department && item.department.toLowerCase().includes(query)) ||
      (item.currency_type &&
        item.currency_type.toLowerCase().includes(query)) ||
      (item.price_start && item.price_start.toString().includes(query)) ||
      (item.price_end && item.price_end.toString().includes(query))
    );
  });

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, buyerAdmin_approverRange_search } =
      JSON.parse(chatActionRaw);

    if (action === "search_pr_approver_range") {
      if (!filteredData || filteredData.length === 0) return;

      console.log(buyerAdmin_approverRange_search?.searchText);
      setSearchQuery(buyerAdmin_approverRange_search?.searchText || "");
      setPageNumber(1);

      sessionStorage.removeItem("CHAT_ACTION");
    }

    if (action === "add_pr_approver_range") {
      handleOpenAddItem();
    }
  }, [filteredData]);

  // viewItemsActionButtons
  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={"OK"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleCloseViewItemPopup}
    />,
  ];

  const viewUserChildren = [
    <InfoLabel
      size={"44%"}
      label={"Stage Name"}
      value={uniqueData?.slab_name}
    />,
    <InfoLabel
      size={"44%"}
      label={"Start price"}
      value={formatInrAmount(uniqueData?.price_start)}
    />,
    <InfoLabel
      size={"44%"}
      label={"End Price"}
      value={formatInrAmount(uniqueData?.price_end)}
    />,
    <InfoLabel
      size={"44%"}
      label={"Approvers"}
      value={
        uniqueData?.usersList ? (
          <ul>
            {uniqueData.usersList.map((user, index) => (
              <li key={index}>{user.approver_name}</li>
            ))}
          </ul>
        ) : (
          "-"
        )
      }
    />,
  ];

  const handleDeleteSlab = async (row) => {
    const formData = new FormData();
    formData.append("id", row.id);
    formData.append("admin_token", user_token);

    try {
      const response = await axios.post(
        API_ENDPOINT.delete_pr_slab_config,
        formData,
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      if (response.status === 200) {
        handleGetPOslab(); // refresh table
      }
    } catch (error) {
      console.error(
        "Error deleting PR slab:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <div className={classes.slab_tab_wrapper}>
      <HeaderTitle titleText={"Value-Based Purchase Request Approval"} />

      <div className={classes.search_add_wrapper}>
        <SearchBar
          onChange={(query) => {
            setSearchQuery(query);
            setPageNumber(1);
          }}
        />

        <Dbutton
          labelImg={plusIcon}
          iconWidth="1rem"
          iconHeight="1rem"
          label="PR APPROVAL MATRIX"
          btnHeight="4rem"
          onClick={handleOpenAddItem}
        />
      </div>

      <div className={classes.d_dataTable}>
        <DataTable
          headings={Tableheadings}
          tableData={filteredData}
          actions={true}
          stickyHead={true}
          stickyFirstColumn={true}
          stickyFirstColumnOffset={0}
          tableSize={itemsData?.length === 0 ? "100%" : "100%"}
          viewBtn={true}
          sorting={true}
          viewClick={(token, row) => handleOpenViewItemPopup(row)}
          editBtn={true}
          editClick={(token, row) => handleEditAddItem(row)}
          deleteBtn={true}
          deleteClick={(token, row) => handleDeleteSlab(row)}
        />
      </div>

      <Modal
        open={openapprovalmodal}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade>
          <PopupFrame
            poupHeading={viewUserHeading}
            actionButtons={viewTextActionButtons}
            inputChildren={PoslabItemInputs}
          />
        </Fade>
      </Modal>

      <Modal
        open={openViewItemPopup}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openViewItemPopup}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={viewUserChildren}
              poupHeading={viewUserHeading}
              actionButtons={viewItemsActionButtons}
              closePopup={handleCloseViewItemPopup}
              width={"auto"}
              customClass={classes.addPopup}
              styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      <Modal open={successpopup}>
        <Fade in={successpopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={`${
                isEditMode
                  ? "PR Approval Slab Updated!!"
                  : "PR Approval Slab Created!!"
              }`}
              popupDescription={`${
                isEditMode
                  ? "PR slab configuration updated successfully"
                  : "PR slab configuration saved successfully"
              }`}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={handleBack}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default PRApproverSlab;
